import i18n from "src/i18n";


export const getCreatePatientSteps = () => [
  {
    position: 1,
    title: i18n.t("personal"),
  },
  {
    position: 2,
    title: i18n.t("emergency"),
  },
  {
    position: 3,
    title: i18n.t("lifestyle"),
  },
  {
    position: 4,
    title: i18n.t("vitals"),
  },
  {
    position: 5,
    title: i18n.t("billing"),
  },
];
